<template>
	<svg :viewBox="viewBox">
		<use :xlink:href="href" />
	</svg>
</template>

<script>

	import _ from 'lodash'
	import * as sprites from "../../sprites/*.svg"

	export default {
		name: 'sprite',
		props: {
			name: { type: String, required: true }
		},
		data () {
			return {
				sprites
			}
		},
		computed: {
			sprite () {
				return this.sprites[this.name]
			},
			viewBox () {
				return _.get(this.sprite, "viewBox")
			},
			href () {
				let id = _.get(this.sprite, "id")
				return `#${id}`
			}
		}
	}

</script>

<style lang="scss" scoped>
	svg {
		pointer-events:none;
	}
</style>



// WEBPACK FOOTER //
// src/components/_global/sprite.vue